module.exports = "<div class='notifications-list'>\n  <div *ngFor=\"let notification of notifications.list\"  class='alert notification' [ngClass]='notification.cssClass'>\n      <i class='material-icons'>{{notification.icon}}</i> \n      <p>{{notification.text}}</p>\n  </div>\n</div>\n\n<div class='loader-div alert alert-loading' [ngClass]=\"loader.status ? 'show' : ''\">\n\t<div>\n\t\t<div class='loader'></div>\n    \t<p>{{loader.text}}</p>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/notification/notification.component.html
// module id = ./src/app/notification/notification.component.html
// module chunks = main